import {frontend} from 'pageflow-scrolled/frontend';

import {BlogPosts} from './BlogPosts';

frontend.contentElementTypes.register('blogPosts', {
  component: BlogPosts
});
